import React, { PropsWithChildren, useEffect } from 'react';
import { X } from 'react-feather';
import { useLocation } from 'react-router';

import Button from '@/componentsv2/Button';
import { Drawer } from '@/componentsv2/Drawer';

const MobileNavDrawer = ({
  children,
  open,
  handleClose,
}: PropsWithChildren<{
  open: boolean;
  handleClose: () => void;
}>): React.JSX.Element => {
  const location = useLocation();
  useEffect(() => {
    handleClose();
  }, [handleClose, location]);

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      size="xs"
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: 430,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <header className="flex h-[68px] items-center justify-between border-b border-gray-200 pl-20 pr-16">
        <h2 className="m-0 text-20 font-semibold text-on-surface">Menu</h2>
        <Button
          variant="tertiary"
          srText="close"
          onClick={handleClose}
          startIcon={X}
          size="large"
        />
      </header>
      <Drawer.Main bgClassName="bg-surface-card">
        <nav aria-label="Site Navigation">
          <ul className="space-y-2 !text-20 text-on-surface hd-4">{children}</ul>
        </nav>
      </Drawer.Main>
    </Drawer>
  );
};

export default MobileNavDrawer;
